import React, { FC, ReactElement } from 'react'

import { Page } from '../../components'
import { ConnectedAbsences } from '../../connectors'

const AbsencesPage: FC = (): ReactElement => (
    <Page className="absences-page">
        <ConnectedAbsences />
    </Page>
)

export default AbsencesPage

